import { TUseServiceRequestsOptions } from '@commenda/types/src/service-request/types';
import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';
import { buildPaginatedQueryString } from './useServiceRequestsPaginated';

type CountOptions = TUseServiceRequestsOptions;

export const useServiceRequestsCount = (options?: CountOptions) => {
  const key = buildPaginatedQueryString(options, "/count");

  const { data, error, mutate, isLoading, isValidating } = useSWR<{
    count: number;
  }>(
    key,
    key
      ? SWRFetcher(
        {
          method: 'GET',
        },
        undefined
      )
      : null
  );

  return {
    count: data?.count ?? 0,
    error,
    mutate,
    isLoading: !!isLoading,
    isValidating: !!isValidating,
  };
};
